import React from 'react';
import { Outlet } from 'react-router-dom';

import { RequestProvider } from '@common/react/components/RequestProvider/RequestProvider';

import AttentionMessagesWrapper from '@app/components/UI/AttentionMessage/AttentionMessagesWrapper';
import CookieBanner from '@app/components/UI/CookieBanner/CookieBanner';
import { SentryErrorBoundary } from '@app/components/UI/ErrorBoundary/SentryErrorBoundary';
import RequestWithTimeoutProvider from '@app/providers/RequestWithTimeoutProvider/RequestWithTimeoutProvider';

const LayoutWrapper: React.FC = () => {
	const hiddenStyles: React.CSSProperties = {
		display: 'none',
		visibility: 'hidden',
	};

	return (
		<SentryErrorBoundary>
			<RequestProvider>
				<RequestWithTimeoutProvider>
					<noscript>
						<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-53KG2QP" height="0" width="0" style={hiddenStyles} title="ns.html?id=GTM-53KG2QP" />
					</noscript>
					<Outlet />
					<CookieBanner />
					<AttentionMessagesWrapper />
				</RequestWithTimeoutProvider>
			</RequestProvider>
		</SentryErrorBoundary>
	);
};
export default LayoutWrapper;
